import { nanoid } from "nanoid";
import { findStringBetweenMatchingBrace, getMatchesFromString, stripCommentsAndEmptyLinesFromCode } from "../../helpers/parseHelpers";
import { IModelInfo, IModelMemberInfo } from "../ModelInfos/IModelInfo";

export function parseTypescript(data: string): IModelInfo[] {
    const code = stripCommentsAndEmptyLinesFromCode(String(data));
    console.log("typescript parse 1", code);
    const typesWithCode = getNamespacesAndTypesFromCode(code);

    const result: IModelInfo[] = [];
    for (const typeWithCode of typesWithCode) {
        console.log("typescript parse 2", typeWithCode);
        const model = parseModelFromCode(typeWithCode);
        if (model) {
            result.push(model);
        }
    }

    console.log("typescript parse 3", result);
    return result;
}

interface RelatedCode {
    typeKind: string;
    typeName: string;
    code: string;
    imports: string[];
}
function* getNamespacesAndTypesFromCode(code: string): Iterable<RelatedCode> {
    // const reNamespace = /\b(namespace)\s*?([^\s]+)/gi;
    const reUsings = /^\s*?import\s*?([^\s]+)\s*;/gmi;
    const imports = Array.from(getMatchesFromString(code, reUsings)).map(x => x[1]);

    const reClass = /\b(class|interface)\s+?([^\s():]+)/gi;
    for (const match of getMatchesFromString(code, reClass)) {
        console.log("found", match);
        const [value, typeKind, typeName] = match;
        const start = match.index! + value.length - 1;
        const relatedCode = findStringBetweenMatchingBrace(code, start, "{", "}");
        if (relatedCode && relatedCode.trim().length > 0) {
            yield {
                typeKind,
                typeName,
                code: relatedCode,
                imports
            };
        }
    }
}

function parseModelFromCode(typeWithCode: RelatedCode): IModelInfo | undefined {
    const { code, typeName, imports } = typeWithCode;

    const publicProps = /\b([_a-zA-Z0-9?]+)\s*:\s*([_a-zA-Z0-9<>[\]?]+?)\s*[,;{=]/gm;

    let props = Array.from(getMatchesFromString(code, publicProps));

    const members: IModelMemberInfo[] = props.map(x => {
        let name = x[1];
        const typeName = x[2];

        const nullable = name.endsWith("?");
        if (nullable) {
            name = name.slice(0, -1);
        }

        return {
            id: nanoid(),
            name: name,
            originalName: name,
            nullable: nullable,
            type: {
                name: typeName,
                originalName: typeName
            }
        };
    });

    const model: IModelInfo = {
        id: nanoid(),
        importId: nanoid(),
        created: new Date(),
        namespace: "default",
        name: typeName,
        originalName: typeName,
        extends: [],
        imports,
        members
    };
    return model;
}
